import styled from 'styled-components';

import { StopPropagation } from './events';

export const ContentWrapper = styled(StopPropagation)`
  display: flex;
  justify-content: space-between;
`;

export const Key = styled.span`
  min-width: 110px;
`;

export const Value = styled.span`
  font-weight: 500;
  max-width: 200px;
  word-break: break-word;
`;

export const StyledLink = styled.a`
  margin-top: auto;
  margin-left: 20px;
  height: fit-content;
  text-decoration: none;

  padding: 5px 10px;
  border-radius: 3px;

  color: ${({ theme }) => theme.colors.fontTangerine};
  background-color: ${({ theme }) => theme.colors.tangerineLight};

  &:hover,
  &:focus {
    color: ${({ theme }) => theme.colors.fontTangerine};
  }
`;

export const InfoWrapper = styled.div`
  display: flex;

  &:not(:last-child) {
    margin-bottom: 10px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/ui-helpers/popover.js